import { ID, LifeArea } from '@griply/types';

export const getLifeAreaIdsToArchive = (
  lifeAreas: Pick<LifeArea, 'id' | 'templateId' | 'archivedAt'>[],
  deselectedTemplateIds: ID[],
): ID[] =>
  lifeAreas
    .filter(
      (lifeArea) =>
        lifeArea.templateId !== null &&
        deselectedTemplateIds.includes(lifeArea.templateId) &&
        !lifeArea.archivedAt,
    )
    .map((lifeArea) => lifeArea.id);
